import {
  DataBox,
  DataBoxLegendProps,
  DataBoxBaseProps,
} from 'src/components/molecules/DataBox';
import { currencyValueTickFormatter } from 'src/utils/TickFormatters';
import { useCurrency } from 'src/hooks/useCurrency';
import { Optimization } from '../../types';
import { NewBarGraph } from 'src/components/molecules/graphs/NewBarGraph';

type InvestmentByMediaBarGraphProps = {
  optimization: Optimization;
} & DataBoxBaseProps;

const INITIAL_KEY = 'Initial investment';
const OPTIMIZED_KEY = 'Optimized investment';

export const InvestmentByMediaBarGraph: React.FC<
  InvestmentByMediaBarGraphProps
> = ({ optimization, ...dataBoxProps }) => {
  const { code } = useCurrency();
  const data = optimization.data.map((opt) => ({
    [INITIAL_KEY]: opt.initialInvestment,
    [OPTIMIZED_KEY]: opt.optimizedInvestment,
    channel: opt.channelName,
  }));

  const dataKeys = {
    xAxis: 'channel',
    data: [INITIAL_KEY, OPTIMIZED_KEY],
  };

  const legendProps: DataBoxLegendProps = {
    baseLegendKeys: dataKeys.data,
    placement: 'top',
  };

  return (
    <DataBox
      {...dataBoxProps}
      legendProps={legendProps}
      isError={false}
      isLoading={false}
      hasData={data.length > 0}>
      <NewBarGraph
        data={data}
        xAxisKey={dataKeys.xAxis}
        stacked={false}
        yAxisFormatter={currencyValueTickFormatter(code)}
      />
    </DataBox>
  );
};
